import { createContext } from 'react';
import { ErrorMessage } from '../common/types';
export interface ErrorMessageState {
    message: ErrorMessage | undefined;
    setErrorMessage: (message: ErrorMessage | undefined) => void;
}

export const ErrorMessageContext = createContext<ErrorMessageState>({ message: undefined, setErrorMessage: () => {} });